import { Suspense } from "react";
import { Ability } from "~auth/Ability.ts";
import { usePermitted } from "~auth/usePermitted.ts";
import { useCurrentEmployee } from "~contexts/CurrentEmployeeContext/CurrentEmployeeContext.tsx";
import { envFromHostname } from "~lib/envHelpers.ts";
import { lazyWithRetry } from "~lib/lazyWithRetry.ts";
import { BetaSetting } from "./BetaSetting";
import { LanguageSetting } from "./LanguageSetting.tsx";
import { NextProjectNumber } from "./NextProjectNumber.tsx";
import { ResetAppDataButton } from "./ResetAppDataButton.tsx";

const NalPeriodSeeder = lazyWithRetry(() =>
  import("~components/Controlling/NalDashboard/NalPeriodSeeder.tsx").then(
    (m) => ({ default: m.NalPeriodSeeder }),
  ),
);

export function Settings() {
  const { currentEmployee } = useCurrentEmployee();
  const permitted = usePermitted();
  const canViewNextProjectNumber = permitted([
    Ability.canViewNextProjectNumber,
  ]);
  const isStagingOrDevelopment = ["development", "staging"].includes(
    envFromHostname(),
  );

  return (
    <>
      <LanguageSetting />
      <BetaSetting currentEmployee={currentEmployee} />
      <ResetAppDataButton />
      {canViewNextProjectNumber && <NextProjectNumber />}
      {isStagingOrDevelopment && (
        <Suspense fallback={null}>
          <NalPeriodSeeder />
        </Suspense>
      )}
    </>
  );
}
